export class TokenActions {
    public static IN = 'IN';
    public static OUT = 'OUT';
}
